import { OrganizationPickerComponent } from '@app/sidebar-layout/components/organization-picker/organization-picker.component';
import { ClipboardCopyModule } from '@shared/clipboard-copy/clipboard-copy.module';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { CommonModule, NgOptimizedImageModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
	imports: [
		FormsModule,
		CommonModule,
		BsDropdownModule,
		Ng2SearchPipeModule,
		ClipboardCopyModule,
		ReactiveFormsModule,
		NgOptimizedImageModule,
	],
	declarations: [OrganizationPickerComponent],
	exports: [OrganizationPickerComponent],
})
export class OrganizationPickerModule {}
